import styled from 'styled-components'

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 8px;
  gap: 2px;
  border-radius: 200px;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  background-color: ${({ variant }) => {
    if (variant === 'pixError') return '#AD1F22'
    if (variant === 'inProgress') return '#0088CC'
    if (variant === 'done') return '#12B76A'
    if (variant === 'analysis') return '#0088CC'
    return '#AD1F22'
  }};
`
